import React from "react";

import EditMessages from "./Edit/Edit";
import { Breadcrumb } from "../../../components";

export default ({ match, history, ...props }) => {
  const idEdit = match !== undefined ? match.params.id : false;
  return (
    <div>
      <Breadcrumb
        title="Criar Modelo"
        renderLeft={(() => (
          <div
            className="breadcrumb-left-actions pointer"
            onClick={() => history.goBack()}
          >
            <svg width="16" height="14" viewBox="0 0 16 14">
              <path d="M4.044 8.003l4.09 3.905-1.374 1.453-6.763-6.356L6.759.639 8.135 2.09 4.043 6.003h11.954v2H4.044z" />
            </svg>
          </div>
        ))()}
        description="Crie ou gerencie modelos."
      />

      <EditMessages idEdit={idEdit} {...history} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/screens/admin/MessageModels/ManageMessageCategorys.js